"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dismissReportsForContent = exports.listReports = exports.reportContent = void 0;
const unifiedFirestoreService_1 = require("./unifiedFirestoreService");
/**
 * Submit a content or user report.
 *
 * Reports land in `reports/{contentType}_{contentId}_{reporterUid}` — only
 * admins can read (see firestore.rules). Deterministic doc ID prevents
 * duplicate reports from the same user for the same content.
 */
function reportContent(params) {
    return __awaiter(this, void 0, void 0, function* () {
        const { contentType, contentId, reporterUid, contentAuthorUid, contentLabel } = params;
        const reportId = `${contentType}_${contentId}_${reporterUid}`;
        yield (0, unifiedFirestoreService_1.unifiedSetDoc)('reports', reportId, {
            contentType,
            contentId,
            reporterUid,
            contentAuthorUid: contentAuthorUid !== null && contentAuthorUid !== void 0 ? contentAuthorUid : null,
            contentLabel: contentLabel !== null && contentLabel !== void 0 ? contentLabel : null,
            reportedAt: new Date().toISOString(),
        }, /* merge */ true);
        console.log(`🚩 ReportsService: reported ${contentType} ${contentId} by ${reporterUid}`);
    });
}
exports.reportContent = reportContent;
/**
 * List all content reports, newest first. Admin-only (enforced by Firestore rules).
 */
function listReports(limitCount = 200) {
    return __awaiter(this, void 0, void 0, function* () {
        const docs = yield (0, unifiedFirestoreService_1.unifiedCollection)('reports')
            .orderBy('reportedAt', 'desc')
            .limit(limitCount)
            .getDocs();
        return docs.map(d => {
            var _a, _b, _c, _d, _e;
            const r = d.data();
            return {
                id: d.id,
                contentType: ((_a = r === null || r === void 0 ? void 0 : r.contentType) !== null && _a !== void 0 ? _a : 'crewPost'),
                contentId: String((_b = r === null || r === void 0 ? void 0 : r.contentId) !== null && _b !== void 0 ? _b : ''),
                reporterUid: String((_c = r === null || r === void 0 ? void 0 : r.reporterUid) !== null && _c !== void 0 ? _c : ''),
                contentAuthorUid: (_d = r === null || r === void 0 ? void 0 : r.contentAuthorUid) !== null && _d !== void 0 ? _d : null,
                contentLabel: (_e = r === null || r === void 0 ? void 0 : r.contentLabel) !== null && _e !== void 0 ? _e : null,
                reportedAt: typeof (r === null || r === void 0 ? void 0 : r.reportedAt) === 'string' ? r.reportedAt : '',
            };
        });
    });
}
exports.listReports = listReports;
/**
 * Delete all report docs for a given contentId. Call after deleting/actioning the content.
 */
function dismissReportsForContent(contentId) {
    return __awaiter(this, void 0, void 0, function* () {
        const docs = yield (0, unifiedFirestoreService_1.unifiedCollection)('reports')
            .where('contentId', '==', contentId)
            .getDocs();
        yield Promise.all(docs.map(d => (0, unifiedFirestoreService_1.unifiedDeleteDoc)('reports', d.id)));
        console.log(`✅ ReportsService: dismissed ${docs.length} report(s) for contentId=${contentId}`);
    });
}
exports.dismissReportsForContent = dismissReportsForContent;
